/* UTM capture & persistence.
 *
 * Marketing UTMs (utm_source, utm_medium, utm_campaign, utm_content,
 * utm_term, gclid) are captured on first landing and kept in sessionStorage
 * so they survive in-app navigation and can be attached to the enquiry
 * source — no PII involved.
 */

const KEY = "fedari_utm";
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid"];

export function captureUtm() {
  if (typeof window === "undefined") return;
  try {
    const q = new URLSearchParams(window.location.search);
    let rec = {};
    try { rec = JSON.parse(window.sessionStorage.getItem(KEY) || "{}"); } catch { /* fresh */ }
    PARAMS.forEach((p) => { const v = q.get(p); if (v) rec[p] = v.slice(0, 120); });
    // Attribution context — recorded once, on first landing.
    if (!rec.landing_page) rec.landing_page = window.location.pathname.slice(0, 200);
    if (!rec.referrer && document.referrer) rec.referrer = document.referrer.slice(0, 200);
    if (Object.keys(rec).length) window.sessionStorage.setItem(KEY, JSON.stringify(rec));
  } catch { /* storage unavailable — non-fatal */ }
}

export function getUtm() {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(window.sessionStorage.getItem(KEY) || "{}");
  } catch { return {}; }
}

// Compact "?utm_source=…" suffix for the enquiry source field (empty if none).
export function utmSuffix() {
  const utm = getUtm();
  const keys = Object.keys(utm);
  if (!keys.length) return "";
  return "?" + keys.map((k) => `${k}=${encodeURIComponent(utm[k])}`).join("&");
}
